import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles'
import Button from '../button/Button'
import { useMediaQuery } from 'react-responsive'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { useDispatch } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import Icon from '../icon/Icon'
import { ButtonBase } from '@material-ui/core'
import iconsEnum from '../../enums/iconsEnum'
import { displayModal } from '../../modules/reducers/modal/actions'
import { modalTypes } from '../../enums/modalTypeEnum'
import { saveInteractions } from '../../modules/gtm/utils/gtmCallback'

const useStyle = makeStyles((theme) => (
	{
		...styles(theme),
		topAlertStyle: {
			background: theme.palette.accessibility.main,
			width: '100%',
			color: 'white',
			marginBottom: 25,

			'& .container': {
				position: 'relative',
				display: 'flex',
				alignItems: 'center',
				textAlign: 'left',
				width: '80%',
				maxWidth: 1100,
				margin: 'auto',
				padding: '25px 0',

				'& div:first-child': {
					width: '65%',
					marginRight: 60,

					'& p:first-child': {
						marginTop: 0
					},
					'& p:last-child': {
						marginBottom: 0
					}
				},
				'& div:nth-child(2)': {},
				'& img': {
					position: 'absolute',
					top: 15,
					right: 0,
					width: 24,
					background: '#4cc4c2',
					padding: 7,
					borderRadius: '100%',
					boxSizing: 'border-box',
					cursor: 'pointer'
				}
			}
		},
		topAlertLargeScreenStyle: {
			paddingTop: 100
		},
		topAlertSmallScreenStyle: {
			paddingTop: 65,
			'& .container': {
				'& div:first-child': {
					marginRight: 10
				}
			}
		},
		circularProgressStyle: {
			marginBottom: 20
		},
		circularProgressLargeScreenStyle: {
			paddingTop: 100
		},
		circularProgressSmallScreenStyle: {
			paddingTop: 65
		},
		closeButton: {
			width: 24,
			height: 24,
			borderRadius: 40,
			position: 'absolute',
			top: 15,
			right: 0,
			background: theme.palette.accessibilityGreenToWhite['70'],
			padding: 7,
			'& svg': {
				fill: theme.palette.textAccessibility.main
			}
		}
	}
))

interface AcceptingProps {
	onCustomAlertClosed: () => void
}

type CustomAlertProps =
	AcceptingProps

const PrelevementAlert: React.FC<CustomAlertProps> = (
	{
		onCustomAlertClosed
	}
) => {
	const classes = useStyle()
	const intl = useIntl()

	const dispatch = useDispatch()

	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const topAlertClass: ClassValue = classNames(
		classes.topAlertStyle,
		{
			[classes.topAlertLargeScreenStyle]: isLargeScreen,
			[classes.topAlertSmallScreenStyle]: !isLargeScreen
		}
	)

	const closeButtonClass: ClassValue = classNames(
		classes.closeButton
	)

	return (
		<div className={topAlertClass}>
			<div className="container">
				<div>
					<p className={classes.text4}>
						<FormattedMessage
							id="customAlert.title"
							defaultMessage="Prélèvement automatique"
							description="Custom Alert Title"
						/>
					</p>

					<p className={classes.text1}>
						<FormattedMessage
							id="customAlert.informations"
							defaultMessage="Adoptez le prélèvement automatique et simplifiez-vous la gestion de votre location."
							description="Custom Alert Informations"
						/>
					</p>
				</div>


				<div>
					<Button
						onClick={() => {
							saveInteractions(
								{
									category: 'Mes Services',
									action: 'Souscrire en ligne',
									label: 'Mes Services::Souscrire en ligne::call to action'
								}
							)

							dispatch(displayModal(modalTypes.prelevement))
						}}
						color="colorWhite"
						textStyle="text2"
						disabled={false}
						background="backgroundInherit"
						border="borderWhite"
						ariaLabel={
							intl.formatMessage(
								{
									id: 'customAlert.subscribe',
									defaultMessage: 'Souscrire',
									description: 'Aria label text'
								}
							)
						}
					>
						<FormattedMessage
							id="customAlert.subscribe"
							defaultMessage="Souscrire"
							description="Button text Subscribe"
						/>
					</Button>
				</div>

				<ButtonBase
					className={closeButtonClass}
					onClick={onCustomAlertClosed}
					aria-label={
						intl.formatMessage(
							{
								id: 'customAlert.hideAlert',
								defaultMessage: 'Masquer l\'alerte',
								description: 'Aria label hide alert'
							}
						)
					}
				>
					<Icon icon={iconsEnum.Cross} size={11} />
				</ButtonBase>
			</div>
		</div>
	)
}

export default PrelevementAlert